import AppNavigator from './sidebar'

export default AppNavigator
